import { StripeOverdueService } from './services/StripeOverdueService';
import type { Init } from './types';
import { managerHelpers } from '../../helpers';
import type { MergedDataReturnType, MergedHandlersReturnType } from '../../types';
import { WithApi } from '../WithApi';

export type StripeOverdueBannerData = MergedDataReturnType<[StripeOverdueService]>;

export type StripeOverdueBannerHandlers = MergedHandlersReturnType<[StripeOverdueService]>;

type TApi = ReturnType<StripeOverdueService['api']>;

export class StripeOverdueBannerManager extends WithApi<TApi> {
  public stripeOverdueBannerInit = ({ t, queries }: Init) => {
    const [hasStripeOverdueQuery, stripePortalQuery] = queries;

    const pending = hasStripeOverdueQuery.isPending || stripePortalQuery.isPending;
    const error = hasStripeOverdueQuery.error || stripePortalQuery.error;

    if (pending) {
      return {
        status: 'pending',
        data: null,
        handlers: null,
      } as const;
    }

    if (error) {
      return {
        status: 'error',
        data: error,
        handlers: {
          retry: () => {
            managerHelpers.retryQueries(queries);
          },
        },
      } as const;
    }

    const service = new StripeOverdueService(!!hasStripeOverdueQuery.data, t, stripePortalQuery.data);

    this.initApi({
      ...service.api(),
    });

    return {
      status: 'loaded',
      data: {
        ...service.data(),
      },
      handlers: {
        ...service.handlers(),
      },
    } as const;
  };
}
